// extracted by mini-css-extract-plugin
export default {"appWrapper":"ApartmentStackPageLayout_appWrapper__OJdQE","appHeader":"ApartmentStackPageLayout_appHeader__4Swoj"};